import axios from "axios";

import { baseURL } from "../../../utils/http/http-common";

export const getFinalAssessmentApiCall = async (userId) => {
  const userTypeId = localStorage.getItem('userTypeId');

  const authToken = localStorage.getItem("token");

  const response = await axios.get(
    `${baseURL}/FinalAssessment/GetFinalAssessmentData/${userId}/${userTypeId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      }
    }
  );

  if (!response?.data?.response) {
    throw new Error("Final assessment data unavailable");
  }

  return response;
};

export const uploadDocumentApiCall = async (body) => {
  const userTypeId = localStorage.getItem('userTypeId');
  const userId = localStorage.getItem('id');
  const authToken = localStorage.getItem("token");

  const formData = new FormData();

  // append multiple files
  body.forEach((file) => {
    formData.append('files', file);
  });

  try {
    const response = await fetch(`${baseURL}/FinalAssessment/UploadDocuments/${userId}/${userTypeId}`,{
      method:"POST",
      body:formData,
      headers:{
        Authorization: `Bearer ${authToken}`,
      }
    })

    const data = await response.json();

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
